export default __webpack_public_path__ + "static/media/github.925002c4.svg";